import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { CaretRightSquareFill } from "react-bootstrap-icons";
import ModalD from "../components/Modal";
import { Button, Table } from "react-bootstrap";
import FilterBar from "../components/filterBar";
let wilburk = false;
const CatalogoList = ({ ...props }) => {
  const [data, setData] = useState();
  const [filters, setFilters] = useState(null);
  const [filteredData, setFilteredData] = useState();
  const [modalData, setModalData] = useState();
  const [show, setShow] = useState(false);
  const [compatible, setCompatible] = useState();

  const [itemOffset, setItemOffset] = useState(0);

  const itemsPerPage = 10;

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = filteredData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filteredData?.length / itemsPerPage);

  const ImageUrl =
    "http://www.sir-autoparts.com/application-catalog/images/0210005.jpg";

  const getData = async () => {
    try {
      const res = await fetch(
        "https://sheets.googleapis.com/v4/spreadsheets/1WewTOvSEcplLVXuKN5E5Kph_f3td-MD3_y7XsUevYBM/values/sheet1/?alt=json&key=AIzaSyAp1SoceM96fjHishU3HU2gni4C1pJpbfs"
      );
      const response = await res.json();

      setData(response?.values);

      setFilteredData([]);
      setModalData(response?.values);
    } catch (error) {
      console.log(error);
    }
  };
  let transformedValues = data?.slice(1).map((entry) => {
    let [
      Codice,
      Casa,
      AYD,
      BIRTH,
      DELPHI,
      DYS,
      Descrizione,
      FEBI,
      FRAP,
      IR,
      MB,
      MOOG,
      Modello,
      OCAP,
      OE,
      OP,
      Posizione,
      QH,
      RUVILLE,
      SIDEM,
      TALOSA,
      TRW,
      VEMA,
      WILBURK,
      Note,
    ] = entry;
    return {
      Codice,
      Casa,
      AYD,
      BIRTH,
      DELPHI,
      DYS,
      Descrizione,
      FEBI,
      FRAP,
      IR,
      MB,
      MOOG,
      Modello,
      OCAP,
      OE,
      OP,
      Posizione,
      QH,
      RUVILLE,
      SIDEM,
      TALOSA,
      TRW,
      VEMA,
      WILBURK,
      Note,
    };
  });

  useEffect(() => {
    getData();
  }, []);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % transformedValues.length;
    setItemOffset(newOffset);
  };

  const generateModalDataForDropdown = () => {
    return [
      ...new Set(
        transformedValues && transformedValues?.map((item) => item?.Modello)
      ),
    ];
  };

  const generateBrandDataForDropdown = () => {
    return [
      ...new Set(
        transformedValues && transformedValues?.map((item) => item?.Casa)
      ),
    ];
  };

  // const handleFilterRefrence = (codice) => {
  //   const filterData =
  //     transformedValues &&
  //     transformedValues?.filter((item) => {
  //       if (item.Codice.toLowerCase().includes(codice.toLowerCase())) {
  //         return item;
  //       }
  //     });

  //   setFilteredData(filterData);
  // };

  // const handleFilterOe = (oe) => {
  //   const filterData =
  //     transformedValues &&
  //     transformedValues?.filter((item) => {
  //       if (item?.OE.toLowerCase().includes(oe.toLowerCase())) {
  //         return item;
  //       }
  //     });

  //   setFilteredData(filterData);
  // };

  // const handleFilterModal = (modal) => {
  //   const filterData =
  //     transformedValues &&
  //     transformedValues?.filter((item) => {
  //       if (item?.Modello === modal) {
  //         return item;
  //       }
  //     });

  //   setFilteredData(filterData);
  // };

  // const handleFilterBrand = (casa) => {
  //   const filterData =
  //     transformedValues &&
  //     transformedValues?.filter((item) => {
  //       if (item?.Casa === casa) {
  //         return item;
  //       }
  //     });

  //   setFilteredData(filterData);
  // };

  const handleFilter = (value, field) => {
    // console.log(value, field);

    if (!wilburk) {
      const currentFilter = { ...filters, [field]: value };
      setFilters(currentFilter);

      const filterData =
        transformedValues &&
        transformedValues?.filter((item) => {
          let youShallPass = true;

          if (
            (currentFilter.codice &&
              !item?.Codice.toLowerCase().includes(
                currentFilter.codice.toLowerCase()
              )) ||
            (currentFilter.oe &&
              !item?.OE.toLowerCase().includes(
                currentFilter.oe.toLowerCase()
              )) ||
            (currentFilter.model &&
              !item?.Modello.toLowerCase().includes(
                currentFilter.model.toLowerCase()
              )) ||
            (currentFilter.casa &&
              !item?.Casa.toLowerCase().includes(
                currentFilter.casa.toLowerCase()
              )) ||
            (currentFilter.competitors &&
              !item?.AYD?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.BIRq?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.DELPHI?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.DYS?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.FEBI?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.FRAP?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.IR?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.MB?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.MOOG?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.OCAP?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.OP?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.QH?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.RUVILLE?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.SIDEM?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.TALOSA?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.TRW?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.VEMA?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.WILBURK?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ))
          ) {
            youShallPass = false;
          }

          if (youShallPass) return item;
        });

      // console.log(filterData);
      setFilteredData(filterData);
    } else {
      const currentFilter = { ...filters, [field]: value };
      setFilters(currentFilter);

      const filterData =
        transformedValues &&
        transformedValues?.filter((item) => {
          let youShallPass = true;

          if (
            (currentFilter.codice &&
              !item?.WILBURK.toLowerCase().includes(
                currentFilter.codice.toLowerCase()
              )) ||
            (currentFilter.oe &&
              !item?.OE.toLowerCase().includes(
                currentFilter.oe.toLowerCase()
              )) ||
            (currentFilter.model &&
              !item?.Modello.toLowerCase().includes(
                currentFilter.model.toLowerCase()
              )) ||
            (currentFilter.casa &&
              !item?.Casa.toLowerCase().includes(
                currentFilter.casa.toLowerCase()
              )) ||
            (currentFilter.competitors &&
              !item?.AYD?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.BIRq?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.DELPHI?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.DYS?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.FEBI?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.FRAP?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.IR?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.MB?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.MOOG?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.OCAP?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.OP?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.QH?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.RUVILLE?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.SIDEM?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.TALOSA?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.TRW?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.VEMA?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ) &&
              !item?.Codice?.toLowerCase().includes(
                currentFilter.competitors.toLowerCase()
              ))
          ) {
            youShallPass = false;
          }

          if (youShallPass) return item;
        });

      // console.log(filterData);
      setFilteredData(filterData);
    }
  };

  const handleClose = () => setShow(false);

  const handleClick = (item) => {
    setShow(false);
    const Compatible = transformedValues?.filter((value) => {
      if (value?.Codice === item.Codice) {
        return value;
      }
    });
    setCompatible(Compatible);
    setModalData(item);
    setShow(true);
  };

  return (
    <div>
      <FilterBar
        filters={filters}
        models={generateModalDataForDropdown()}
        casas={generateBrandDataForDropdown()}
        onFilter={handleFilter}
        filteredData={filteredData}
        reset={() => {
          setFilteredData([]);
          setFilters("");
        }}
      />
      {filteredData && filteredData.length ? (
        <>
          <Table responsive>
            <thead
              style={{
                backgroundColor: "black",
                color: "white",
                fontWeight: 700,
              }}
            >
              <tr>
                <th></th>
                <th>Reference</th>
                <th>Brand</th>
                <th>Model</th>
                <th>Description</th>
                <th>Side</th>
                <th>OE</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {currentItems &&
                currentItems?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <img
                        alt={!wilburk ? item?.Codice : item?.WILBURK}
                        src={
                          !wilburk
                            ? "http://www.sir-autoparts.com/application-catalog/images/" +
                              item?.Codice +
                              ".jpg"
                            : "https://www.wilburk.eu/images/" +
                              item?.WILBURK +
                              ".jpg"
                        }
                        width="50"
                        height="50"
                      />
                    </td>
                    <td>{!wilburk ? item?.Codice : item?.WILBURK}</td>
                    <td>{item?.Casa}</td>
                    <td>{item?.Modello}</td>
                    <td>{item?.Descrizione}</td>
                    <td>{item?.Posizione}</td>
                    <td>{item?.OE}</td>
                    <td>
                      <CaretRightSquareFill
                        size={30}
                        className="ml-4"
                        onClick={() => handleClick(item)}
                      />{" "}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
          <div className="pagination-list">
            <ReactPaginate
              breakLabel="..."
              nextLabel="next "
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount ? pageCount : ""}
              previousLabel=" previous"
              renderOnZeroPageCount={null}
              containerClassName="pagination justify-content-center"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
              breakClassName="page-item"
              breakLinkClassName="page-link"
            />
          </div>
        </>
      ) : null}

      <ModalD
        show={show}
        modalData={modalData}
        handleClose={handleClose}
        compatible={compatible}
        handleClick={handleClick}
      />
    </div>
  );
};

export default CatalogoList;
